import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePremiumOrderLogisticGuideInput,
    UpdatePremiumOrderLogisticGuideInput,
    PremiumOrderLogisticGuide,
    LogisticGuideType
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PremiumOrderLogisticGuideService {
    private amplifyClient = generateClient();

    constructor() {}

    async premiumOrderLogisticGuidesByType(
        type: LogisticGuideType
    ): Promise<PremiumOrderLogisticGuide[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PremiumOrderLogisticGuidesByType,
                    variables: {
                        type
                    }
                })
            ).data.PremiumOrderLogisticGuidesByType.items;
            if (data) return data as PremiumOrderLogisticGuide[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }
    async premiumOrderLogisticGuidesByPakmailId(
        pakmailId: string
    ): Promise<PremiumOrderLogisticGuide[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PremiumOrderLogisticGuidesByPakmailId,
                    variables: {
                        pakmailId
                    }
                })
            ).data.PremiumOrderLogisticGuidesByPakmailId.items;
            if (data) return data as PremiumOrderLogisticGuide[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }
    async premiumOrderLogisticGuidesByPremiumOrder(
        premiumOrderId: string
    ): Promise<PremiumOrderLogisticGuide[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PremiumOrderLogisticGuidesByPremiumOrder,
                    variables: {
                        premiumOrderId
                    }
                })
            ).data.PremiumOrderLogisticGuidesByPremiumOrder.items;
            if (data) return data as PremiumOrderLogisticGuide[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }
    async premiumOrderLogisticGuidesByClient(
        clientId: string
    ): Promise<PremiumOrderLogisticGuide[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PremiumOrderLogisticGuidesByClient,
                    variables: {
                        clientId
                    }
                })
            ).data.PremiumOrderLogisticGuidesByClient.items;
            if (data) return data as PremiumOrderLogisticGuide[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }
    async premiumOrderLogisticGuidesByCreator(
        creatorId: string
    ): Promise<PremiumOrderLogisticGuide[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PremiumOrderLogisticGuidesByCreator,
                    variables: {
                        creatorId
                    }
                })
            ).data.PremiumOrderLogisticGuidesByCreator.items;
            if (data) return data as PremiumOrderLogisticGuide[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }

    async createPremiumOrderLogisticGuide(
        input: CreatePremiumOrderLogisticGuideInput
    ): Promise<PremiumOrderLogisticGuide> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPremiumOrderLogisticGuide,
                    variables: {
                        input
                    }
                })
            ).data.createPremiumOrderLogisticGuide;
            if (data) return data as PremiumOrderLogisticGuide;
        } catch (error) {
            console.error('Error creating PremiumOrderLogisticGuide:', error);
            return null;
        }
    }
    async updatePremiumOrderLogisticGuide(
        input: UpdatePremiumOrderLogisticGuideInput
    ): Promise<PremiumOrderLogisticGuide> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePremiumOrderLogisticGuide,
                    variables: {
                        input
                    }
                })
            ).data.updatePremiumOrderLogisticGuide;
            if (data) return data as PremiumOrderLogisticGuide;
        } catch (error) {
            console.error('Error creating PremiumOrderLogisticGuide:', error);
            return null;
        }
    }
}
